import React, { useState, useEffect } from "react"
import "./header.css"
import { nav } from "../../data/Data"
import { Link } from "react-router-dom"
import { useAuth } from "../../../context/AuthContext"
import { authFetch } from "../../../lib/api"

const Header = () => {
  const [navList, setNavList] = useState(false)
  const [savedCount, setSavedCount] = useState(0)
  const { user, logout } = useAuth()

  useEffect(() => {
    if (!user) {
      setSavedCount(0)
      return
    }
    authFetch("/api/saved-homes")
      .then((r) => r.json())
      .then((data) => {
        if (data.savedHomes) setSavedCount(data.savedHomes.length)
      })
      .catch(() => {})
  }, [user])

  const closeMenu = () => setNavList(false)

  return (
    <>
      <header>
        <div className='container flex'>
          <Link to='/' className='logo' onClick={closeMenu}>
            <img src='/images/vista-logo.png' alt='vistahillhouse logo' />
          </Link>
          <div className='nav'>
            <ul className='flex'>
              {nav.map((list, index) => (
                <li key={index}>
                  <Link to={list.path}>{list.text}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className='button flex'>
            {user ? (
              <>
                <Link to='/dashboard/saved-homes'>
                  <h4>
                    <span>{savedCount}</span> My List
                  </h4>
                </Link>
                <Link to='/dashboard' style={{ marginRight: 12 }}>
                  Dashboard
                </Link>
                <button type='button' className='btn1' onClick={logout}>
                  Sign out
                </button>
              </>
            ) : (
              <Link to='/signin'>
                <button className='btn1'>
                  <i className='fa fa-sign-out'></i> Sign In
                </button>
              </Link>
            )}
          </div>

          <button
            className='toggle'
            onClick={() => setNavList(!navList)}
            aria-label={navList ? "Close menu" : "Open menu"}
          >
            <span className={`hamburger ${navList ? "open" : ""}`}>
              <span />
              <span />
              <span />
            </span>
          </button>
        </div>
      </header>

      {/* Mobile menu overlay */}
      <div className={`mobile-menu ${navList ? "open" : ""}`} aria-hidden={!navList}>
        <div className='mobile-menu-backdrop' onClick={closeMenu} />
        <div className='mobile-menu-panel'>
          <nav className='mobile-nav'>
            {nav.map((list, index) => (
              <Link
                key={index}
                to={list.path}
                className='mobile-nav-link'
                onClick={closeMenu}
              >
                {list.text}
              </Link>
            ))}
          </nav>
          <div className='mobile-menu-actions'>
            <Link
              to='/dashboard/saved-homes'
              className='mobile-list-row'
              onClick={closeMenu}
            >
              <span className='mobile-list-badge'>{savedCount}</span>
              <span>My List</span>
            </Link>
            {user ? (
              <>
                <Link to='/dashboard' className='mobile-nav-link' onClick={closeMenu}>
                  Dashboard
                </Link>
                <button type='button' className='mobile-signin btn1' onClick={() => { closeMenu(); logout(); }}>
                  Sign out
                </button>
              </>
            ) : (
              <Link to='/signin' onClick={closeMenu}>
                <button className='mobile-signin btn1'>
                  <i className='fa fa-sign-out'></i> Sign In
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Header
